import { faMegaphone } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/react';
import { IconButton, Tooltip } from '@mui/material';
import { useContext, useEffect, useRef } from 'react';
import { AppSettings } from '@/AppSettings';
import ChosenThemeContext from '@/contexts/styles/ChosenThemeContext';

const ToggleFeedbackButton = () => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const chosenTheme = useContext(ChosenThemeContext);

    useEffect(() => {
        if (!AppSettings.sentry.dsn || !AppSettings.sentry.enableReportABug || !buttonRef.current) {
            return;
        }

        const feedback = Sentry.getFeedback();

        if (!feedback) {
            return;
        }

        return feedback.attachTo(buttonRef.current, {
            colorScheme: chosenTheme === 'dark' ? 'dark' : 'light',
        });
    }, [chosenTheme]);

    if (!AppSettings.sentry.dsn || !AppSettings.sentry.enableReportABug) {
        return null;
    }

    return (
        <Tooltip title="Report a Bug">
            <IconButton ref={buttonRef} aria-label="Report a Bug" color="inherit">
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
};

export default ToggleFeedbackButton;
